import { Injectable } from '@angular/core';
import { Label, LanguageService } from './language.service';

export interface Timespan {
	display: string;
	value: string;
}

@Injectable({
	providedIn: 'root',
})
export class TimespanService {
	// Page langauge.
	labels: { [key in Label]?: string } = {
		[Label.ALL_TIME]: '',
		[Label.DAYS]: '',
		[Label.YEAR]: '',
		[Label.YEARS]: '',
	};

	constructor(private _languageSvc: LanguageService) {
		// Get page language.
		this._languageSvc.getLabels(this.labels);
	}

	get timespans(): Array<Timespan> {
		return [
			{ display: this.labels.allTime, value: null },
			{ display: `30 ${this.labels.days}`, value: '30 days' },
			{ display: `90 ${this.labels.days}`, value: '90 days' },
			{ display: `180 ${this.labels.days}`, value: '180 days' },
			{ display: `1 ${this.labels.year}`, value: '1 year' },
			{ display: `5 ${this.labels.years}`, value: '5 years' },
		];
	}
}
